module.exports = __webpack_public_path__ + "assets/images/rbyearend-18.jpg?v=bbef9396";